define('TescoMobile_Checkout/js/proceed-to-checkout',['jquery', 'Magento_Customer/js/model/authentication-popup', 'TescoMobile_Checkout/js/action/validate-cart-items', 'Magento_Customer/js/customer-data', 'mage/template', 'Magento_Ui/js/modal/confirm'], function ($, authenticationPopup, validateOptions, customerData, mageTemplate, confirmModal) {
  'use strict';

  return function (config, element) {
    $(element).on('click', function (event) {
      var _checkoutConfig$careH;
      var deferred = $.Deferred(),
        self = this,
        checkoutConfig = window.checkoutConfig.tescomobile,
        cartConfig = checkoutConfig === null || checkoutConfig === void 0 || (_checkoutConfig$careH = checkoutConfig.careHub) === null || _checkoutConfig$careH === void 0 ? void 0 : _checkoutConfig$careH.cartConfig;
      validateOptions(deferred);
      $.when(deferred).done(function (result) {
        if (result === true) {
          var cart = customerData.get('cart'),
            customer = customerData.get('customer');
          event.preventDefault();
          if (!customer().firstname && cart().isGuestCheckoutAllowed === false) {
            authenticationPopup.showModal();
            return false;
          }
          if (cartConfig !== null && cartConfig !== void 0 && cartConfig.content && (parseInt(cartConfig === null || cartConfig === void 0 ? void 0 : cartConfig.isPhoneShop) === 1 || parseInt(cartConfig === null || cartConfig === void 0 ? void 0 : cartConfig.isTelesales) === 1)) {
            confirmModal({
              content: cartConfig === null || cartConfig === void 0 ? void 0 : cartConfig.content,
              type: 'slide',
              modalClass: 'carehub-cms-block-modal',
              opened: function () {
                $(this).trigger('contentUpdated');
              },
              buttons: [{
                text: $.mage.__('Continue'),
                class: 'action-primary carehub-copy-continue disabled',
                click: function (event) {
                  this.closeModal(event, true);
                  $(element).attr('disabled', true);
                  location.href = config.checkoutUrl;
                }
              }, {
                text: $.mage.__('Back'),
                class: 'action-primary back',
                click: function (event) {
                  this.closeModal(event, true);
                }
              }],
              clickableOverlay: false
            });
          } else {
            $(element).attr('disabled', true);
            location.href = config.checkoutUrl;
          }
        }
      }.bind(this)).fail(function (response) {
        if (response !== null && response !== void 0 && response.message) {
          self.messages([{
            type: 'error',
            text: $.mage.__(response.message)
          }]);
        } else {
          self.messages([{
            type: 'error',
            text: $.mage.__('Your cart items could not be validated, please check and try again')
          }]);
        }
      }.bind(this));
    });
  };
});

